import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { TravellerFieldEnum } from '@websky/graphql';
import css from './companionItem.module.css';
import { getTravellerFullName, getUserValue } from '../../../../../utils';
import { getDateValue } from './utils';
const CompanionItem = props => {
    const { document, onClick, nationalities } = props;
    const { t } = useTranslation('Passenger');
    const birthDate = getDateValue(document, TravellerFieldEnum.BirthDate);
    const docExpiryDate = getDateValue(document, TravellerFieldEnum.DocExpiryDate);
    // Extract document information
    const docType = getUserValue(document, TravellerFieldEnum.DocType);
    const docNumber = getUserValue(document, TravellerFieldEnum.DocNumber);
    const citizenship = getUserValue(document, TravellerFieldEnum.Citizenship);
    // Check if document information is available
    const hasDocument = Boolean(docType && docNumber);
    const hasExpiryDate = Boolean(docExpiryDate);
    const fullName = getTravellerFullName(document);
    return (React.createElement("div", { className: css.root, onClick: onClick },
        React.createElement("div", { className: css.row },
            React.createElement("span", { className: css.name }, fullName),
            birthDate && React.createElement("span", null, birthDate)),
        hasDocument && (React.createElement("div", { className: cn(css.row, css.doc) },
            React.createElement("span", null,
                t(docType),
                ":"),
            React.createElement("span", null, docNumber))),
        nationalities.has(citizenship) && (React.createElement("div", { className: cn(css.row, css.doc) },
            React.createElement("span", null,
                t('Citizenship'),
                ":"),
            React.createElement("span", null, nationalities.get(citizenship)))),
        hasExpiryDate && (React.createElement("div", { className: cn(css.row, css.expiration) },
            React.createElement("span", null,
                t('expiredDate'),
                ":"),
            React.createElement("span", null, docExpiryDate)))));
};
export default CompanionItem;
